export default __webpack_public_path__ + "static/media/lightTheme.2c8822e9.svg";